import React from 'react';
import classNames from 'classnames';
import styles from './CountBadge.module.scss';

// Small numeric pill for unread/pending counts (sidebar nav, notification
// bells, etc). Renders nothing when there's nothing to count, so call sites
// don't need their own `count > 0 &&` guard.
export const CountBadgeComponent = ({
  count,
  max = 99,
  variant = 'danger',
  className,
}) => {
  if (!count || count <= 0) return null;

  return (
    <span
      className={classNames(
        styles.countBadge,
        styles[`countBadge_${variant}`],
        className
      )}
    >
      {count > max ? `${max}+` : count}
    </span>
  );
};

CountBadgeComponent.displayName = 'CountBadge';
